export default {
  state: {
    id: ''
  },

  mutations: {},

  actions: {}
}
